import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let context = '.blog section:not(.hero)';
if (document.querySelector('body').classList.contains('search') === true) {
    context = '.search section:not(.hero)';
}
if (document.querySelector('body').classList.contains('archive') === true) {
    context = '.archive section:not(.hero)';
}


if (document.querySelector(context)) {

    let mm = gsap.matchMedia();

    let imgArray = gsap.utils.toArray([`${context} .width-animation`, `${context} .width-animation-reverse`, `${context} .height-animation`, `${context} .height-animation-reverse`]);

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (animContext) => {
        let { isMobile, isDesktop } = animContext.conditions;
        let offset = isMobile ? 100 : 200;

        imgArray.forEach((img) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: img,
                    start: `center bottom`,
                    end: 'bottom top',
                    once: true,
                    onEnter: self => {
                        setTimeout(() => {
                            if (img.classList.contains('big')) {
                                self.trigger.style.setProperty('--animWidth', "100%");
                            } else {
                                setTimeout(() => {
                                    self.trigger.style.setProperty('--animWidth', "100%");
                                }, 300);
                            }
                            
                        }, 200);
                    },
                },
            });
        });
        
    });

}
